import { configPromise } from "../../config/configMiddleware";
import { deleteWith, getWith, patchWith, postWith, updateWith } from "../axios";

// Get All Message
export async function GetAllMessage(brandId: number): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/message/fetch-messages/${brandId}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// Get A Message
export async function GetMessage(partnerId: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/message/` + partnerId;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// Create Message
export async function CreateMessage(message: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/message`;
    return (await postWith<any, any>(url, message)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// update status
export async function UpdateMessageStatus(
  discoveryBrandId: any,
  partnerId: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/message/update-message-status/${discoveryBrandId}/${partnerId}`;
    return (await updateWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// Update Message
export async function UpdateMessage(
  partnerId: any,
  message: {
    message: any;
    url: any;
    status: any;
  }
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/message/${partnerId}`;
    return (await postWith<any, any>(url, message)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// Soft Delete Message
export async function SoftDeleteMessage(partnerId: string): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v2/message/soft-delete/` + partnerId;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// Hard Delete Message
export async function HardDeleteMessage(partnerId: string): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v2/message/hard-delete/` + partnerId;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// Recover Soft Deleted Message
export async function DecoverSoftDeletedMessa(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/message/restore/` + partnerid;
    return (await patchWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

// Get Discovery Message
export async function GetDiscoveryMessage(
  discoveryBrandId: any,
  partnerId: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/message/discovery/${discoveryBrandId}/${partnerId}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}
